import React from "react";
import { Box, Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { ExpandCircleDownOutlined } from "@mui/icons-material";
import { challanDataList } from "../../constants/externalInformationData";
import { GridContainer } from "./GridStructure";

const challanHeaderStyles = {
  width: "221px",
  margin: "unset",
  fontSize: "12px",
  fontWeight: "500",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

function Challan({ content }) {
  return content && Object?.keys(content)?.length ? (
    <Box sx={{ fontFamily: "inter" }}>
      <Box sx={{ marginBottom: "2rem", padding: "0 2rem" }}>
        <Grid container md={4} columnSpacing={4}>
          <Grid item md={6} sx={{ fontSize: "11px" }}>
            Total Number of Challans:
          </Grid>
          <Grid
            item
            md={6}
            sx={{
              paddingLeft: "1.6rem !important",
              fontSize: "12px",
              fontWeight: "600",
              color: "#3A3A3A",
            }}
          >
            {content?.totalCount || 0}
          </Grid>
        </Grid>
      </Box>

      <Box>
        <Grid container columnSpacing={3}>
          {content?.challanDetails?.map((details, index) => (
            <Grid item md={4} key={"challan" + index}>
              <Box sx={{ m: 1 }}>
                <Accordion
                  sx={{
                    boxShadow: "none",
                    ".MuiAccordionSummary-root": {
                      height: "4rem",
                      marginBottom: "unset",
                    },
                    ".MuiAccordionSummary-root.Mui-expanded": {
                      minHeight: "auto",
                      background:
                        details?.challanStatus?.toLowerCase() === "paid"
                          ? "linear-gradient(180deg, #156A3A 51.61%, #3C9563 100%)"
                          : "linear-gradient(180deg, #E42125 17.74%, #E94D51 100%)",
                    },
                    ".MuiAccordionSummary-content": {
                      color: "#3A3A3A",
                      margin: "8px 0",
                    },
                    ".MuiAccordionSummary-content.Mui-expanded": {
                      color: "#FFFFFF",
                      margin: "8px 0",
                    },
                    ".MuiAccordionSummary-expandIconWrapper": {
                      color: "#E8505B",
                    },
                    ".MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                      color: "#FFFFFF",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandCircleDownOutlined
                        sx={{ width: "18px", height: "18px" }}
                      />
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{
                      minHeight: "auto",
                      padding: "0 8px",
                      border: "1px solid #E8E8E8",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography sx={challanHeaderStyles}>
                      {`Challan ${details?.number} - ${details?.offenseDetails}`}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      border: "1px solid #E8E8E8",
                      borderRadius: "4px",
                      marginTop: "2px",
                    }}
                  >
                    <Typography>
                      {challanDataList?.map((item, index) => (
                        <GridContainer
                          key={`${item}${index}`}
                          item={item}
                          content={details}
                        />
                      ))}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  ) : (
    <div
      style={{
        margin: "20px 7px",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        color: "grey",
      }}
    >
      <h3>No data</h3>
    </div>
  );
}

export default Challan;
